import React from 'react';
import { Dropdown } from '@components/common/Dropdown';
import { media } from '@styles/mediaQuery';
import styled from 'styled-components';

interface PerPageSelectProps {
  value: number;
  onChange: (value: number) => void;
  options?: number[];
}

/**
 * 페이지당 항목 수 선택 드롭다운 컴포넌트
 * @param value - 현재 선택된 페이지당 항목 수
 * @param onChange - 값 변경 시 호출되는 콜백 함수
 * @param options - 선택 가능한 항목 수 배열 (기본값: [10, 20, 50, 100])
 */
const PerPageSelect: React.FC<PerPageSelectProps> = ({
  value,
  onChange,
  options = [10, 20, 50, 100],
}) => {
  return (
    <PerPageDropdown className="per-page-select">
      <select value={value} onChange={(e) => onChange(Number(e.target.value))}>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}개씩 보기
          </option>
        ))}
      </select>
    </PerPageDropdown>
  );
};

export default PerPageSelect;

const PerPageDropdown = styled(Dropdown)`
  flex: 0 0 auto;

  ${media.tablet`
    width: auto;

    select {
      width: auto;
      min-width: 7.75rem;
      min-height: ${({ theme }) => theme.control.heightSm};
      border-color: ${({ theme }) => theme.neutralGray[300]};
      border-radius: ${({ theme }) => theme.radius.sm};
      background-color: ${({ theme }) => theme.white};
    }
  `}
`;
